<!-- 库房报溢数据操作 -->
<template>
   <div>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }"
                       @tabHeight="(val) => { mxHeight = val }">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0">
                           <el-form class="baseForm" id="mainInfo" label-width="100px" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                              <el-row>
                                 <el-form-item :label="formOneValue.showField" size="mini" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                               :key="formOneKey" :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>

                                    <!-- 不合格数量 -->
                                    <el-input v-if="formOneValue.entityField == 'rumNumber'" :disabled="formOneValue.isChange == 0" type="number" @input="input(formOneValue.entityField)"
                                              v-model.number="sendDataInfo[formOneValue.entityField]"></el-input>

                                    <el-tooltip v-else-if="formOneValue.fieldType == 'extract'" class="item"
                                                :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9"
                                                effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                       <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                 @keyup.enter.native="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)"
                                                 :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                          <el-button @click="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)" slot="append" icon="el-icon-search"
                                                     :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1"></el-button>
                                       </el-input>
                                    </el-tooltip>

                                    <!-- 登记日期 -->
                                    <df-date v-else-if="formOneValue.fieldType == 'date'" :isShowLong="false" v-model="sendDataInfo[formOneValue.entityField]"
                                             :isdisabled="formOneValue.entityField == 'expidate' || formOneValue.entityField == 'prodate' || formOneValue.isChange == 0" />
                                    <el-input v-else-if="formOneValue.entityField == 'lumReason' || formOneValue.entityField == 'rumReason'" v-model="sendDataInfo[formOneValue.entityField]"
                                              :disabled="formOneValue.isChange == 0" type="textarea">
                                    </el-input>
                                    <el-input v-else v-model="sendDataInfo[formOneValue.entityField]" :disabled="formOneValue.isChange == 0">
                                    </el-input>
                                 </el-form-item>
                              </el-row>
                              <el-row v-if="dataActionBox.actionType == 2">
                                 <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                    <span v-if="formOneValue.isRift == 1">
                                       <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                          sendDataInfo[formOneValue.entityField] }}</a>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                       <span v-if="sendDataInfo[formOneValue.entityField]">
                                          {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                       </span>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'formatter'">
                                       {{ $common.getIsGsp(formOneValue.formatterContent,
                                          sendDataInfo[formOneValue.entityField]) }}
                                    </span>

                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                           <!-- 明细 -->
                           <el-form :inline="true" size="mini">
                              <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                 <el-button type="primary" size="mini" @click="addDetails('sendDataInfo')">新增</el-button>

                                 <el-button type="primary" size="mini" @click="deleteDetails()">删除
                                 </el-button>

                              </div>
                              <el-table size="mini" ref="mxTableRef" :height="mxHeight" id="mxTable" :data="sendDataInfo.details" border style="width: 100%">
                                 <el-table-column label="选择操作" width="80">
                                    <template slot-scope="scope">
                                       <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                          <i class="el-icon-thumb"></i>
                                       </el-radio>
                                    </template>
                                 </el-table-column>
                                 <el-table-column align="center" width="180" :prop="formOneValue.entityField" :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in mxForm" :key="formOneKey"
                                                  v-if="formOneValue.isShow == 1">
                                    <template slot-scope="scope">
                                       <!-- 系统字段 -->

                                       <el-input v-if="formOneValue.fieldType == 'search' && dataActionBox.actionType != 2" clearable v-model="sendDataInfo.details[scope.$index][formOneValue.entityField]"
                                                 @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)">
                                          <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>
                                       </el-input>
                                       <!-- 生产日期 -->
                                       <span v-else-if="formOneValue.fieldType == 'date'">
                                          <span v-if="sendDataInfo.details[scope.$index][formOneValue.entityField]">
                                             {{ $common.getLocalTime(sendDataInfo.details[scope.$index][formOneValue.entityField]) }}
                                          </span>
                                       </span>
                                       <!-- 不合格数量 -->
                                       <el-input v-else-if="formOneValue.entityField == 'lumNumber'" type="number" @input="input(formOneValue.entityField)"
                                                 v-model.number="sendDataInfo.details[scope.$index][formOneValue.entityField]"></el-input>

                                       <!-- 生产日期 -->
                                       <span v-else-if="formOneValue.entityField == 'prodate'">
                                          <span v-if="sendDataInfo.details[scope.$index][formOneValue.entityField]">
                                             {{ $common.getLocalTime(sendDataInfo.details[scope.$index][formOneValue.entityField]) }}
                                          </span>
                                       </span>
                                       <span v-else>
                                          {{ sendDataInfo.details[scope.$index][formOneValue.entityField] }}
                                       </span>
                                    </template>
                                 </el-table-column>

                              </el-table>
                           </el-form>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>

            <!-- 页脚 -->
            <div class="foot">
               <div>
                  <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary" @click="showPrintPlan">打印
                  </el-button>
                  <el-button type="primary" @click="initActionBox('sendDataInfo')" v-if="dataActionBox.actionType != 2">取消</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 0">保存</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">保存</el-button>
               </div>
               <div v-if="footForm">
                  <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline">
                     <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
                        <el-button type="success">{{ sendDataInfo[itemV.entityField] }}</el-button>
                     </el-form-item>
                  </el-form>
               </div>
            </div>
         </div>
      </div>
      <!-- 检索方案弹窗 -->
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
      <el-dialog top="1vh" :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
         <ExtractionScheme ref="extractionScheme" :ppId="ppId" :id="exId" @TranData="getExData" @getWidth="getExWidth" @sendTitle="getExtractName" />
      </el-dialog>
   </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
export default {
   name: "unqualifiedDamageAction",
   props: ["actionData"],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
      ExtractionScheme,
   },
   data() {
      //这里存放数据
      return {
         options: [],
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {
            ovmAppdate: "",
            ovmAppreason: "",
            ovmApptype: 0,
            ovmReserves1: "",
            ovmReserves2: "",
            ovmReserves3: "",
            ovmReserves4: "",
            ovmReserves5: "",
            ovmReserves6: "",
            ovmId: "",
            details: [],

         },
         detaislDataInfo: {},
         showTabs: "",
         formDataList: [],
         seTitle: "", //检索
         DialogVisible: false,
         seWidth: "0",
         seId: 0,
         parentSearchData: {},
         selectedDetailsIndex: 0, //选择索引
         seIndex: 0, //检索焦点索引
         mxHeight: 0,
         tabForm: [],
         mxForm: [],
         footForm: [],
         sField: "",
         exId: "",
         ppId: "rumRegno",
         DialogExtract: false,
         exWidth: "",
         exTitle: "",
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.details": {
         handler: function (newValue, oldValue) {
            this.sendDataInfo.totalCount = 0; //总条目数
            this.sendDataInfo.totalMoney = 0; // 总金额
            this.sendDataInfo.totalNumber = 0; // 总数量
            newValue.forEach((item, keys) => {



            });

         },

         deep: true,
      },
   },
   //方法集合
   methods: {

      openExComponents(e, index) {
         console.log(e);
         this.exId = e;
         this.seIndex = index
         this.init()
         this.DialogExtract = true;
         removeEventListener('keyup', this.keyUp)
      },
      // 获取 提取单数据
      async getExData(res) {
         let val = JSON.parse(JSON.stringify(res))
         console.log('提取', val);
         if (val != "" || val != undefined) {
            for (let key in val) {
               if (key == "arrlistbychen") {
                  this.sendDataInfo.details = val.arrlistbychen;
                  this.sendDataInfo.details.forEach((item, index) => {
                     item.lumNumber = item.rumNumber;
                  })
               } else {
                  this.sendDataInfo[key] = val[key];

               }
            }


            // console.log(this.sendDataInfo);
         } else {
            this.$message({
               message: '未拿到数据',
               type: 'error'
            })
         }
         this.DialogExtract = false
      },
      closeChild() {
         addEventListener('keyup', this.keyUp)//创建监听键盘事件
      },
      getExWidth(e) {
         this.exWidth = e + "%";
      },



      getWidth(e) {
         this.exWidth = e + "%";
      },
      getExtractName(e) {
         this.exTitle = e;
      },
      extract(sId) {
         this.DialogVisible = true;
         this.seId = sId;
         this.seType = "extract";
         this.parentSearchData.foType = 1
         console.log(this.sendDataInfo);
         // this.seIndex
      },
      showPrintPlan() {
         // 打印方法
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(
               this.actionData.orderId,
               this.actionData.printSouce,
               this.actionData.printJurId
            );
         } else {
            return;
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.sendDataInfo[item] = val[item];
         });
      },
      // 表格赋值字段
      mxParamValue(val) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.sendDataInfo.details[this.seIndex][item] = val[item];
         });
         this.sendDataInfo.details.splice(1, 0);
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         this.sField = sField;
         this.seIndex = index;
         this.DialogVisible = true;
         this.seId = sId;
         this.parentSearchData[type] =
            this.sendDataInfo.details[index][type];

      },
      //检索带回数据
      changeInputModel(val) {
         console.log("返hui", val);
         if (val != "" || val != undefined) {
            this.DialogVisible = false; //关闭商品检索窗口
            //赋值给当前行
            if (val.bgmId) {
               if (this.sendDataInfo.details.length == 0) {
                  this.sendDataInfo.details.push({})
               }
               for (const key in val) {
                  if (Object.hasOwnProperty.call(val, key)) {
                     this.$set(
                        this.sendDataInfo.details[this.seIndex],
                        key,
                        val[key]
                     );
                  }
               }

            }

            // this.mxParamValue(val);
         } else {
            this.DialogVisible = false;
            this.$message({
               message: "检索失败",
               type: "error",
            });
         }
         console.log("检索返后", this.sendDataInfo);
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },

      //确认新增
      async sendDataAction(formName) {

         this.$refs[formName].validate((valid) => {
            if (valid) {
            } else {
               this.$message({
                  message: "请完善必填信息",
                  type: "error",
               });

               return false;
            }
         });

         // 备份原始的rumReason数组
         let originalRumReason = null;
         if (this.sendDataInfo.rumReason != null && this.sendDataInfo.rumReason != "" && this.sendDataInfo.rumReason != undefined) {
            // 确保rumReason是数组类型
            if (Array.isArray(this.sendDataInfo.rumReason)) {
               originalRumReason = [...this.sendDataInfo.rumReason]; // 创建副本
               this.sendDataInfo.rumReason = this.sendDataInfo.rumReason.join(',');
            }
         }

         if (this.dataActionBox.actionType == 0) {
            var responseData = await this.$http.addUnqualifiedDamage(
               this.sendDataInfo
            );
         } else {
            var responseData = await this.$http.setUnqualifiedDamage(
               this.sendDataInfo
            );
         }
         if (responseData.status == 200) {
            this.$emit("drawerCancel", 1);
            this.init();
            this.$message({
               message: "操作成功",
               type: "success",
            });
         } else {
            // 失败时恢复原始的rumReason数组
            if (originalRumReason !== null) {
               this.sendDataInfo.rumReason = originalRumReason;
            }
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      //新增明细
      addDetails(formName) {
         // 1. 表单校验
         if (!this.validateForm(formName)) {
            return false;
         }

         // 2. 检查是否有未完成的明细行
         if (this.hasIncompleteDetail()) {
            this.focusIncompleteDetail();
            return false;
         }

         // 3. 添加新明细行
         this.createNewDetail();

         // 4. 聚焦到新行
         this.focusNewDetail();
      },

      // 校验表单
      validateForm(formName) {
         let isValid = true;
         this.$refs[formName].validate((valid) => {
            if (!valid) {
               this.$message({
                  message: "请完善必填信息",
                  type: "error",
               });
               isValid = false;
            }
         });
         return isValid;
      },

      // 检查是否有未完成的明细行
      hasIncompleteDetail() {
         return this.sendDataInfo.details.some(item => !item.bgmId);
      },

      // 聚焦到未完成的明细行
      focusIncompleteDetail() {
         const incompleteIndex = this.sendDataInfo.details.findIndex(item => !item.bgmId);
         if (incompleteIndex !== -1) {
            this.selectedDetailsIndex = incompleteIndex;
            this.$nextTick(() => {
               this.selectTableRow(incompleteIndex);
               this.tableNextFocus("bgmName", incompleteIndex);
            });
         }
      },

      // 创建新明细行
      createNewDetail() {
         const newDetail = { ...this.detaislDataInfo };
         this.sendDataInfo.details.push(newDetail);
      },

      // 聚焦到新明细行
      focusNewDetail() {
         const newIndex = this.sendDataInfo.details.length - 1;
         this.selectedDetailsIndex = newIndex;
         this.$nextTick(() => {
            this.selectTableRow(newIndex);
            this.tableNextFocus("bgmName", newIndex);
         });
      },

      // 选中表格行
      selectTableRow(index) {
         const refsElTable = this.$refs.mxTableRef;
         if (refsElTable) {
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(this.sendDataInfo.details[index]);
         }
      },
      // 表格切换焦点方法
      tableNextFocus(field, index) {
         this.seIndex = index;
         if (field == "keydown") {
            if (this.sendDataInfo.details[index + 1] != undefined) {
               this.$refs["bgmName"][index + 1].focus();
               this.selectedDetailsIndex = index + 1;
               this.$nextTick(() => {
                  let refsElTable = this.$refs.mxTableRef;
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(
                     this.sendDataInfo.details[this.selectedDetailsIndex]
                  );
               });
               return;
            }
            this.addDetails("sendDataInfo");
            return;
         }
         this.$refs[field][index].focus();
      },
      //删除明细
      deleteDetails() {
         if (this.sendDataInfo.details.length < 1) {
            this.$message({
               message: "请先添加明细",
               type: "error",
            });
            return false;
         }
         this.sendDataInfo.details.splice(this.selectedDetailsIndex, 1);
         this.selectedDetailsIndex = 0;
      },
      //初始化
      init() {
         for (let key in this.sendDataInfo) {
            this.sendDataInfo[key] = "";
         }
         this.sendDataInfo.lumDate = this.$moment().valueOf();
         this.sendDataInfo.details = [];
      },
      //取消
      initActionBox(formName) {
         this.$confirm(
            "确定取消" + this.dataActionBox.boxTitle + "吗?",
            "提示",
            {
               confirmButtonText: "确定",
               cancelButtonText: "取消",
               type: "warning",
            }
         )
            .then(() => {
               this.$emit("drawerCancel", 0);
               this.init();
               this.$refs[formName].resetFields();
            })
            .catch(() => { });
      },
      async isShowData(name, value) {
         this.sendDataInfo[name] = value;
      },

      //父级传入
      openBox() {
         this.dataActionBox.actionType = this.actionData.cate;
         this.formDataList = this.actionData.formData;
         var oldData = this.actionData.oldData;
         this.showTabs = this.actionData.formData[0].jciName;
         this.filterMainField();
         this.init();
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
         } else if (this.dataActionBox.actionType == 1) {

            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
            this.sendDataInfo.details = [];
            for (let key in this.sendDataInfo) {
               this.sendDataInfo[key] = oldData[key];
               if (key == "details") {
                  this.sendDataInfo.details = [];
                  oldData.details.forEach((item, keys) => {
                     this.sendDataInfo.details.push(item);
                  });
               }
            }
            this.sendDataInfo.lumCode = oldData.lumCode;
            // 处理不合格原因回显，将逗号分隔的字符串转换为数组
            if (this.sendDataInfo.rumReason && typeof this.sendDataInfo.rumReason === 'string') {
               this.sendDataInfo.rumReason = this.sendDataInfo.rumReason.split(',').filter(item => item.trim() !== '');
            }

            console.log(this.sendDataInfo);
         } else {
            this.dataActionBox.boxTitle = "查看信息";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.sendDataInfo[key] = dataInfo[key];
            }
         }
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight();
               } else {
                  this.mxHeight = this.$common.getHeight();
               }
            }, 16.7);
         });
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = [];
         this.formDataList.forEach((item) => {
            if (item.jciType == 1) {
               mainFormList.push(item);
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
               this.mxForm.forEach((item1) => {
                  if (item1.fieldType == "number") {
                     this.$set(this.detaislDataInfo, item1.entityField, 0);
                  } else if (item1.fieldType == "search" && item1.setField) {
                     var arr = item1.setField.split(",");
                     arr.forEach((item2) => {
                        this.$set(this.detaislDataInfo, item2, "");
                     });
                  } else {
                     this.$set(this.detaislDataInfo, item1.entityField, "");
                  }
               });
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
            }
         });
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key));
            this.tabForm[i].jurconfigform = [];
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1)
                  this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
            }
         });
         var arr = [{ entityField: "details" }];
         var obj = this.$common.filterMainFields(
            this.formDataList,
            arr,
            mainFormList[0]
         );
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key]);
         }

         this.$set(this.sendDataInfo, "lumDate", this.$moment().valueOf())
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.$nextTick(() => {
         this.openBox();
      
      });

   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
   width: 100%;
}

.el-drawer {
   outline: none;
}

/* 表格样式更改*/
#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
   margin-bottom: 0;
}
</style>